import React from "react";
import AppRouter from "./config/AppRouter";
import "animate.css/animate.compat.css";
import withRoot from "./withRoot";
function App() {
  return <AppRouter />;
}

export default withRoot(App);
